export default __webpack_public_path__ + "static/shs-logo-9bb651c75e78389ac5fa91ebae0b2947.png";